import React from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'

import Panel from '../../UniformComponents/Panel'
import HoverInfo from '../../UniformComponents/HoverInfo'
import InfoAccordion from '../InfoAccordion'
import StatusBadge from '../Survey/components/StatusBadge'

import './distribute.scss'

@observer
class DistributionNavigation extends React.Component {
    componentDidMount() {
        const { store } = this.props

        store.setNavigationActiveTab()
    }

    componentDidUpdate() {
        const { store } = this.props

        store.setNavigationActiveTab()
    }

    render() {
        const {
            store: {
                navigationActiveTab,
                helperVisible, toggleHelperVisible,
                getNavigationLinks,
                store,
            },
        } = this.props
        const navigationLinks = getNavigationLinks()

        return (
            <Panel cssClass="distribute-filter-panel overflow-visible">
                <div className="heading">
                    <h3>{i18n.t('distributionNavigation.title')}</h3>

                    {process.env.SURVEY_STATE_REBRAND_2026 && (
                        <StatusBadge status={store.surveyStatus} />
                    )}
                </div>

                <InfoAccordion
                    title={i18n.t('searchLayout.getStartGuide')}
                    show={helperVisible}
                    toggle={toggleHelperVisible}
                    cssClass="distribute-info-content"
                    infoContentClass="p-8"
                >
                    <div dangerouslySetInnerHTML={{__html: i18n.t('distributionNavigation.helperContent')}}/>
                </InfoAccordion>

                <div className="options-container align-left">
                    {navigationLinks.map(({ icon, name, onClick, label, disable = false }, i) => (
                        <>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <b
                                    onClick={() => disable ? null : onClick()}
                                    className={`is-link ${disable ? 'disabled-link' : ''} ${navigationActiveTab === name ? 'is-active' : ''}`}
                                >
                                    <i className={icon} />
                                    {i18n.t(label)}
                                </b>

                                {disable
                                    ? (
                                        <HoverInfo
                                            cssClass="hover-info"
                                            desc={i18n.t('rapidSurvey.disabledFeatureTitle')}
                                            linkText={i18n.t('rapidSurvey.disabledFeatureBody')}
                                            href="mailto:support@explori.com"
                                            dir="right"
                                        >
                                            <i className="far fa-lock-keyhole tooltip-icon" style={{ fontSize: 16 }} />
                                        </HoverInfo>
                                    ) : null}
                            </div>
                            {i < (navigationLinks.length - 1) && (
                                <hr />
                            )}
                        </>
                    ))}
                </div>
            </Panel>
        )
    }
}

export default DistributionNavigation
